import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgArrowLeftLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M20.071 12a1 1 0 0 1-1 1H7.343l5.364 5.364a1 1 0 0 1-1.414 1.414l-7.071-7.07a1 1 0 0 1 0-1.415l7.07-7.071a1 1 0 1 1 1.415 1.414L7.343 11h11.728a1 1 0 0 1 1 1'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgArrowLeftLine)
export default ForwardRef
